import React from 'react';
import { FiBlobAvatar } from '../fi/fi-blob-avatar';
import { PEERSONA_CHIP_BG, PEERSONA_TEXT_MUTED, PEERSONA_TEXT_SECONDARY } from '../peersona/peersona-styles';
import { ConversationRow } from './conversation-row';

/** Static Fi row pinned to the top of both list views (no Fi history backend). */
export const FiPinnedRow: React.FC<{ body: string; onClick: () => void }> = ({ body, onClick }) => (
  <ConversationRow
    avatar={<FiBlobAvatar size={48} />}
    title="Fi Concierge"
    body={body}
    ariaLabel="Open Fi concierge"
    onClick={onClick}
  />
);

/** Tinted full-width "Peersonas:" divider between Fi and the Peersona rows. */
export const PeersonasSectionHeader: React.FC = () => (
  <div className="w-full px-4 py-1" style={{ backgroundColor: PEERSONA_CHIP_BG }} role="presentation">
    <span className="font-albert-sans text-sm font-semibold tracking-tight" style={{ color: PEERSONA_TEXT_MUTED }}>
      Peersonas:
    </span>
  </div>
);

/** Inline status line used while loading or when the list is empty. */
export const ListViewMessage: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className="font-open-sans px-4 py-4 text-xs" style={{ color: PEERSONA_TEXT_SECONDARY }}>
    {children}
  </p>
);
